import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2606/logo.png';
import Title from '../img/event/2606/title.png';
import Text from '../img/event/2606/text.png';
import Text2 from '../img/event/2606/text2.png';
import Text3 from '../img/event/2606/text3.png';
import BeforeAndAfter from '../img/event/2606/b&a.png';
import Box from '../img/event/2606/box.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';
import { TextBox } from './common/TextBox';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const HomeschoolEvent202606 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#2384EE]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col gap-10 pt-8 sm:gap-20 sm:pt-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 젭스 영어교실 로고 */}
            <div className="mx-auto flex max-w-[100px] pb-4 sm:max-w-[150px] md:max-w-[180px]">
              <img src={Logo} alt="젭스 영어교실 로고" />
            </div>

            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex flex-col">
                <img
                  src={Title}
                  alt="신앙도, 영어도 이번 여름 뜨겁게 달아오르자! 여름맞이 June비해요"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FFD129]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col gap-8 px-5 py-6 sm:gap-10 sm:py-20">
          {/* 말풍선 섹션 */}
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 타이틀 문구 */}
            <div className="pb-2 pt-2 text-center text-lg font-bold text-[#2384EE] sm:text-2xl md:text-3xl">
              아직 늦지 않았어요!
              <br />
              지금이 바로 우리 아이 학습 습관 완성할
              <br />
              <p className="mt-2 inline-block bg-[#2384EE] px-2 text-xl font-bold text-[#FFD129] sm:text-3xl md:text-4xl">
                골든타임
              </p>
            </div>

            <div className="mx-auto flex max-w-[300px] pt-4 sm:max-w-[400px] md:max-w-[500px]">
              <img src={Text} alt="젭스니까 이 모든 게 가능해요" />
            </div>

            <div className="mx-auto flex max-w-[350px] pb-4 sm:max-w-[450px] md:max-w-[600px]">
              <img src={BeforeAndAfter} alt="before -> after" />
            </div>
          </section>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#201A05]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-10 px-5 py-10 sm:gap-20 sm:py-20">
          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 섹션 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-xl font-semibold text-white sm:text-3xl">
                신앙과 영어 모두 성장할 수 있는 기회!
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-2xl font-extrabold text-white sm:text-4xl">
                젭스영어교실 6월 온라인 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/10"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 온라인 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex items-center justify-center bg-[#FF6D70]">
        <div className="m-auto flex w-full max-w-[720px] flex-col px-5 py-10 sm:px-10 sm:py-16">
          {/* 타이틀 */}
          <div className="mx-auto flex max-w-[350px] pt-4 sm:max-w-[450px] md:max-w-[600px]">
            <img src={Text3} alt="젭스영어교실은 된다!" />
          </div>

          {/* 흰색 카드 */}
          <section className="px-5 py-8 sm:px-10 sm:py-10">
            <div className="flex items-center justify-center">
              {['성경\n스토리', '청크\n학습', '스피킹', '발표'].map(
                (label, index, arr) => (
                  <React.Fragment key={label}>
                    <div className="flex h-24 w-20 items-center justify-center rounded-2xl bg-white text-center text-sm font-extrabold leading-tight text-black shadow-sm sm:h-36 sm:w-32 sm:rounded-[28px] sm:text-lg sm:text-xl md:h-40 md:w-36 md:text-2xl">
                      {label.split('\n').map((text) => (
                        <React.Fragment key={text}>
                          {text}
                          <br />
                        </React.Fragment>
                      ))}
                    </div>

                    {index < arr.length - 1 && (
                      <div className="relative z-20 -ml-1 -mr-1 flex h-5 w-5 items-center justify-center rounded-full border border-[#FF5B66] bg-white text-sm font-black sm:h-6 sm:w-6 sm:text-2xl">
                        &nbsp;
                        <ChevronRightIcon className="h-3 w-3 text-[#FF5B66] sm:h-5 sm:w-5" />
                        &nbsp;
                      </div>
                    )}
                  </React.Fragment>
                ),
              )}
            </div>
          </section>

          {/* 타이틀 */}
          <div className="flex flex-col items-center text-center">
            <p className="text-md mt-6 text-center font-bold leading-relaxed text-white sm:text-xl md:text-2xl">
              한 달에 교재 1세트로 완성!
            </p>
            <p className="text-center text-2xl font-bold leading-relaxed text-[#FFD129] sm:text-3xl md:text-4xl">
              이게 어떻게 가능할까요?
            </p>

            <div className="mx-auto flex max-w-[150px] pb-10 pt-4 sm:max-w-[330px] md:max-w-[400px]">
              <img src={Box} alt="물음표 상자" />
            </div>
          </div>

          <section className="flex w-full flex-col gap-5 sm:gap-8">
            <div className="grid auto-rows-fr grid-cols-1 gap-5">
              <TextBox className="h-full">
                <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                  청크<span className="text-black">로 자연스럽게 배우는</span>{' '}
                  영어 원리
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                  발명 특허받은 교수법<span className="text-black">으로</span>
                  <br />
                  <span className="text-black">
                    성경 스토리를 확실하게 암송
                  </span>
                </p>
              </TextBox>
              <TextBox className="h-full">
                <p className="text-lg font-extrabold text-[#F25952] sm:text-2xl md:text-3xl">
                  <span className="text-black">스토리텔링 & 발표 학습</span>
                </p>
              </TextBox>
            </div>
          </section>
        </div>
      </div>

      {/* 프로모션 섹션 5 */}
      <div className="flex items-center justify-center bg-[#2384EE]">
        <div className="m-auto flex w-full max-w-[720px] flex-col px-5 py-10 sm:px-10 sm:py-16">
          {/* 타이틀 */}
          <p className="text-center text-xl font-extrabold leading-relaxed text-white sm:text-2xl md:text-3xl">
            말씀을 반석으로!
            <br />
            하나님의 지혜로! 돌파해 나가는
          </p>

          <div className="mx-auto flex max-w-[250px] pt-4 sm:max-w-[330px] md:max-w-[400px]">
            <img src={Text2} alt="완벽한 영어학습법" />
          </div>

          {/* 버튼 */}
          <div className="mt-9 sm:mt-14">
            <DoubleLineWithCursorButton
              onClick={() => {
                window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
              }}
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="px-5 py-3 text-base font-bold sm:px-8 sm:py-5 sm:text-2xl md:text-4xl">
                6월 젭스영어교실&nbsp;
                <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
              </div>
            </DoubleLineWithCursorButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202606;
